import React from "react";
import { Button } from "antd";

const IconButton = ({
  type,
  label,
  size = "lg",
  disable = false,
  onClick,
  htmlType = null,
  className,
  icon,
  width,
  style,
}) => {
  const { pixels, unit } = width || { pixels: null, unit: null };

  const styles = {
    width:
      width && typeof width === "object" ? `${pixels}${unit}` : `${width}px`,
    ...style,
  };

  const onButtonClick = (e) => {
    e.preventDefault();
    !disable && onClick && onClick(e);
  };

  return (
    <Button
      htmlType={htmlType}
      id={label}
      className={`${className} button-box-shadow button-${size || "default"} ${
        !disable ? `icon-enabled` : `icon-disabled`
      }`}
      onClick={onButtonClick}
      style={{ ...styles }}
    >
      {icon && <span>{icon}</span>}
    </Button>
  );
};

export default IconButton;
